export const TRAVEL_FUSION = 'travelFusion'
export const AMADEUS = 'amadeus'
export const JETSTAR = 'jetstar'
export const SABRE = 'sabre'
